<div class="text-center dl-abdtp-{{ _model.viewName }}-view ">
  <div class="datepicker__top-navigation">
    <div class="top-navigation__item ml-8 pl-4">
      <button
        class="ctrl color-gray-dark"
        type="button"
        [attr.aria-label]="_model.leftButton.ariaLabel"
        [attr.title]="_model.leftButton.ariaLabel"
        [ngClass]="_model.leftButton.classes"
        (click)="_onLeftClick()"
      >
        <app-icon [glyph]="'arrow-left'" [size]="'14'" [color]="'gray-dark'"></app-icon>
      </button>
    </div>

    <div
      class="top-navigation__item top-navigation__item-current color-blue-dark"
      *ngIf="_model.viewName === (this.maxView || 'year'); then maxViewLabel; else defaultViewLabel"
    ></div>

    <div class="top-navigation__item mr-8 pr-4">
      <button
        class="ctrl color-gray-dark"
        type="button"
        [attr.aria-label]="_model.rightButton.ariaLabel"
        [attr.title]="_model.rightButton.ariaLabel"
        (click)="_onRightClick()"
        [ngClass]="_model.rightButton.classes"
      >
        <app-icon [glyph]="'arrow-right'" [size]="'14'" [color]="'gray-dark'"></app-icon>
      </button>
    </div>
  </div>
  <div (keydown)="_handleKeyDown($event)">
    <div *ngIf="_model.rowLabels?.length" class="datepicker__name-days-parent">
      <div class="datepicker__name-days">
        <div *ngFor="let label of _model.rowLabels" class="color-gray-dark">
          {{ label }}
        </div>
      </div>
    </div>
    <div
      [ngClass]="{
        'datepicker__days pt-8 pb-8': _model.viewName === 'day',
        datepicker__month: _model.viewName === 'month',
        datepicker__year: _model.viewName === 'year',
        'pt-16 pb-24': _model.viewName === 'month' || _model.viewName === 'year'
      }"
    >
      <div
        *ngFor="let row of _model.rows"
        [ngClass]="{
          'days-row': _model.viewName === 'day',
          'month-row': _model.viewName === 'month',
          'year-row': _model.viewName === 'year'
        }"
      >
        <div
          [ngClass]="{
            day: _model.viewName === 'day',
            month: _model.viewName === 'month',
            year: _model.viewName === 'year'
          }"
          [attr.title]="_cellTitle(cell)"
          *ngFor="let cell of row.cells"
        >
          <button
            type="button"
            class="datepicker__button datepicker__button--{{ _model.viewName }} {{ cell.value }}"
            [ngClass]="cell.classes"
            [attr.aria-label]="cell.ariaLabel"
            [attr.aria-disabled]="cell.classes['datepicker__button--disabled']"
            [attr.tabindex]="cell.classes['datepicker__button--active'] ? 0 : -1"
            (click)="_onDateClick(cell)"
            (keydown.space)="_onDateClick(cell)"
            (keydown.enter)="_onDateClick(cell)"
            [disabled]="_checkDisabled(cell)"
          >
            {{ cell.display }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #maxViewLabel>
  <div class="col-10 dl-abdtp-view-label">
    <b class="color-blue-dark">{{ _model.viewLabel }}</b>
  </div>
</ng-template>
<ng-template #defaultViewLabel>
  <button
    class="ctrl link link--dotted-blue-dark font-weight-bold"
    type="button"
    [attr.aria-label]="_model.upButton.ariaLabel"
    [attr.title]="_model.upButton.ariaLabel"
    (click)="_onUpClick()"
    [ngClass]="_model.upButton.classes"
  >
    {{ _model.viewLabel }}
  </button>
</ng-template>
